/**
 * useLiveConversation — is the TRFer's side of the live conversation on
 * screen? (#2566, DECISIONS 2026-10-11 "live conversation is dormant for launch")
 *
 * The live conversation (a family asks for a person, a TRFer claims the thread
 * and replies live) is dormant for launch. The family side has been dark since
 * #1801 behind `HANDOFF_FAMILY_ENTRY_ENABLED`; this hook reads the same server
 * flag for the TRFer shell, so one switch relights both sides. While it is
 * off, Unreads (the nav row), the bell, the thread pages and the Handoff tab
 * of Settings are hidden.
 *
 * Crisis messages do not land here either: TRF is not a crisis line, and a
 * crisis opens no handoff (`CRISIS_HANDOFF_RETIRED` in the backend).
 *
 * Reads the unread-counts query the shell already polls, so it costs no
 * request. Until that query answers, `enabled` is false — the honest default —
 * and `ready` is false so a route guard waits instead of bouncing.
 */
import { useAuth } from '@/contexts/AuthContext';
import { useUnreadCounts } from './useUnreadCounts';

export function useLiveConversation(): { enabled: boolean; ready: boolean } {
  const { user } = useAuth();
  const { data, isSuccess, isError } = useUnreadCounts({ enabled: user?.role === 'trfer' });
  return {
    enabled: data?.live_conversation?.enabled === true,
    ready: isSuccess || isError,
  };
}
